prodUrl = "https://api.phocus1.com/api";
prodGoogleAuthUrl = "https://api.phocus1.com/auth/google";

devUrl = "https://testapi.phocus1.com/api";
devGoogleAuthUrl = "https://testapi.phocus1.com/auth/google";


module.exports = global.config = {
  server_url: devUrl,
  google_auth_url: devGoogleAuthUrl,
  maintenance: false,
};
